import { useEffect } from "react";
import Loader from "../components/widgets/Loader";
import userManager from "../util/userManager";

const Logout = () => {
    // Remove all oidc items from local storage
    // If left in, causes issues with test users signing in/out of different accounts
    useEffect(() => {
        for (let i in localStorage) {
            if (i.includes("oidc")) {
                localStorage.removeItem(i);
            }
        }
        userManager.signoutRedirect();
    }, []);
    
    return (
        <div className="h-screen flex overflow-hidden bg-primary text-primary">
            <Loader />
        </div>
    );
}

export default Logout;